var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCardIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M16,5L0,5L0,3.0000001999999997C0,2.44771528,0.44771528,2,1.0000001,2L15,2C15.552285,2,16,2.44771528,16,3.0000001000000003L16,5ZM1,14C0.44771528,14,0,13.552285,0,13L0,6L16,6L16,13C16,13.552285,15.552285,14,15,14L1,14ZM2,9.5C2,9.776142100000001,2.2238576,10,2.5,10L5.5,10C5.7761421,10,6,9.776142100000001,6,9.5C6,9.2238574,5.7761421,9,5.5,9L2.5,9C2.2238576,9,2,9.2238574,2,9.5ZM2.5,12C2.2238576,12,2,11.7761421,2,11.5C2,11.2238579,2.2238576,11,2.5,11L3.5,11C3.7761424,11,4,11.2238579,4,11.5C4,11.7761421,3.7761424,12,3.5,12L2.5,12Z",
    fillRule: "evenodd",
    fill: "#2BA9DE",
    fillOpacity: 1
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardIcon);
export default __webpack_public_path__ + "static/media/CardIcon.c34981eb1749c2e36469af1d3065f7f6.svg";
export { ForwardRef as ReactComponent };